import type { ObjectValues } from '@/types';

export const APP_ROUTES = {
  ROOT: '/',
  AIRES_METODOLOGY: 'aires-metodology',
  LENDING_METODOLOGY: 'lending-metodology',
  COMMUNITY_METODOLOGY: 'community-metodology',
} as const;

export type AppRoutes = ObjectValues<typeof APP_ROUTES>;
